import React, { useState, useContext } from 'react';
import { Link } from 'react-router-dom';
import { DataContext } from '../../../contexto/ContextoDatos';
import styles from './Productos.module.css';

const PlaceholderIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 64 64"
    width="64"
    height="64"
    fill="none"
    aria-hidden="true"
  >
    <rect x="8" y="20" width="48" height="36" rx="3" stroke="#1e293b" strokeWidth="2.5" />
    <polyline points="8,20 32,8 56,20" stroke="#1e293b" strokeWidth="2.5" strokeLinejoin="round" />
    <line x1="32" y1="8" x2="32" y2="20" stroke="#1e293b" strokeWidth="2.5" />
    <line x1="8" y1="20" x2="56" y2="20" stroke="#1e293b" strokeWidth="2.5" />
    <line x1="20" y1="38" x2="44" y2="38" stroke="#1e293b" strokeWidth="2" strokeLinecap="round" />
    <line x1="26" y1="44" x2="38" y2="44" stroke="#1e293b" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

export const ProductCard = ({ product }) => {
  const { setQuickViewProduct } = useContext(DataContext);
  const [imgError, setImgError] = useState(false);
  const imgSrc = `/imagenes/productos/${product.slug}-1.webp`;

  const handleQuickView = (e) => {
    e.preventDefault(); // Prevent navigating to the product page
    e.stopPropagation();
    setQuickViewProduct(product);
  };

  return (
    <Link to={`/productos/${product.slug}`} className={styles.productCard}>
      <div className={styles.cardImageArea}>
        {!imgError ? (
          <img 
            src={imgSrc} 
            alt={product.name} 
            className={styles.productImage}
            onError={() => setImgError(true)}
          />
        ) : (
          <div className={styles.categoryPlaceholder}>
            <PlaceholderIcon />
          </div>
        )}
        <div className={styles.badgeRow}>
          {product.best_seller && (
            <span className={styles.badgeBestSeller}>BEST SELLER</span>
          )}
          {product.on_demand && (
            <span className={styles.badgeBajoPedido}>BAJO PEDIDO</span>
          )}
      </div>
      </div>

      <div className={styles.cardBody}>
        <p className={styles.cardBrand}>{product.brand}</p>
        <h3 className={styles.cardTitle}>{product.name}</h3>
        {product.model && (
          <p className={styles.cardModel}>Modelo: {product.model}</p>
        )}
        <div className={styles.cardActions}>
          <span className={styles.cardCta}>
            Explorar producto →
          </span>
          <button className={styles.btnQuickView} onClick={handleQuickView} aria-label="Vista rápida">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" width="18" height="18">
              <path strokeLinecap="round" strokeLinejoin="round" d="M2.036 12.322a1.012 1.012 0 010-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178z" />
              <path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
            </svg>
            Vista rápida
          </button>
        </div>
      </div>
    </Link>
  );
};
export default ProductCard;
